import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import DataHeader from "../../global/DataHeader";
import Title from "../../components/Title";
import SubMenu from "../../components/SubMenu";
import { ReactComponent as AnalyticsLogo } from "../../data/svg/6A.svg";
import { ReactComponent as GroupLogo } from "../../data/svg/6334.svg";
import { ReactComponent as AcademyLogo } from "../../data/svg/6334Academy.svg";
import { analyticsMenuOptions, isTabWidth } from "../../data/database";

const linkLogo = [
  { label: "6334", LinkLogoSvg: GroupLogo, link: "/" },
  {
    label: "Academy",
    LinkLogoSvg: AcademyLogo,
    link: "/academy/home",
  },
];

const AnalyticsDownloads = () => {
  const isTab = useMediaQuery(isTabWidth);
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#ebecf0",
        }}
      >
        <DataHeader LogoSvg={AnalyticsLogo} linkLogo={linkLogo} />
        <Box sx={{ backgroundColor: "#ebecf0", height: isTab ? 90 : 130 }} />
        <Box
          sx={{
            backgroundColor: "#ebecf0",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <Title title="Downloads" fontSize={isTab ? "1.25rem" : "2rem"} />
        </Box>
        <Box sx={{ width: "95%", maxWidth: "1200px", margin: "0.75rem auto" }}>
          <SubMenu
            menuOptions={analyticsMenuOptions}
            padding={isTab ? "0.5rem 1rem" : "1rem 2rem"}
            fontSize={isTab ? "0.8rem" : "1rem"}
          />
        </Box>
        <Box
          sx={{
            backgroundColor: "#ebecf0",
            width: "100%",
            height: "100dvh",
          }}
        />
      </Box>
    </>
  );
};

export default AnalyticsDownloads;
